import React from 'react'
// eslint-disable-next-line
import { useMapsLibrary } from '@vis.gl/react-google-maps/dist/index.umd.js'
import { useDispatch, useSelector } from 'react-redux'
import { setDirectionRoutes } from '../../redux/myMapsSlice'

const ROUTE_POLYLINE_COLOR = '#CC5500'

const Directions = ({ map, origin, destination }) => {
  const dispatch = useDispatch()
  const geometryLibrary = useMapsLibrary('geometry')
  const { selectedRouteIndex } = useSelector((s) => s.maps)
  const [routes, setRoutes] = React.useState([])

  React.useEffect(() => {
    if (!geometryLibrary || !origin || !destination) return

    const fetchRoutes = async () => {
      const response = await fetch(
        'https://routes.googleapis.com/directions/v2:computeRoutes',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Goog-Api-Key': process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
            'X-Goog-FieldMask':
              'routes.duration,routes.distanceMeters,routes.polyline.encodedPolyline,routes.legs.polyline.encodedPolyline,routes.legs.steps.navigationInstruction,routes.legs.steps.distanceMeters',
          },
          body: JSON.stringify({
            origin: { address: origin },
            destination: { address: destination },
            travelMode: 'DRIVE',
            computeAlternativeRoutes: true,
          }),
        },
      )

      const data = await response.json()

      const parsedRoutes = (data.routes || []).map((route) => ({
        path: geometryLibrary.encoding.decodePath(
          route.polyline.encodedPolyline,
        ),
        legs: route.legs,
        distanceMeters: route.distanceMeters,
        duration: route.duration,
      }))

      dispatch(setDirectionRoutes(parsedRoutes))
      setRoutes(parsedRoutes)
    }

    fetchRoutes()
  }, [geometryLibrary, origin, destination])

  // Draw/update the route polylines whenever the routes or selected index changes
  React.useEffect(() => {
    if (!map) return undefined

    const newPolylines = routes.map(
      (route, index) =>
        new window.google.maps.Polyline({
          map,
          path: route.path,
          strokeColor: ROUTE_POLYLINE_COLOR,
          strokeWeight: index === selectedRouteIndex ? 6 : 4,
          strokeOpacity: index === selectedRouteIndex ? 1 : 0.5,
          zIndex: index === selectedRouteIndex ? 1 : 0,
        }),
    )

    const selectedRoute = routes[selectedRouteIndex]
    const newMarkers = selectedRoute
      ? [
          new window.google.maps.Marker({
            map,
            position: selectedRoute.path[0],
            label: { text: 'A', color: '#ffffff' },
          }),
          new window.google.maps.Marker({
            map,
            position: selectedRoute.path[selectedRoute.path.length - 1],
            label: { text: 'B', color: '#ffffff' },
          }),
        ]
      : []

    // eslint-disable-next-line consistent-return
    return () => {
      newPolylines.forEach((line) => line.setMap(null))
      newMarkers.forEach((marker) => marker.setMap(null))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map, routes, selectedRouteIndex])

  if (!map) return null
  return null
}

export default Directions
